/**
 * Created by Ning Jiang on 3/20/2017.
 */

import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {HorribleHeroesServerDataParser} from "../HorribleHeroesServerDataParser";
import {IHorribleHeroesInitData} from "./IHorribleHeroesServerData";
import {IBetLineWinData, IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {FeatureBuyTimesBetValue} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";

export class HorribleHeroesParsedInitData extends ParsedInitData {
    private readonly _betWinsWays: IBetLineWinData[] | IBetWayWinData[] | undefined;
    private readonly expandedSymbol: string;
    private readonly gameSizeEnteringFreespin: number[];
    private readonly XSymbolPositions: number[];
    private readonly _lockedWildWindow: boolean[][];
    private readonly _lockedWildNextSpin: boolean[][];
    private readonly _wildMultipliers: number[][];
    private readonly symbolSizesPos: number[][];
    private readonly infectiousPos: number[][];
    private readonly _freespinSpinChoices: number[];
    private readonly _superFSTriggered: boolean;
    private readonly _fsCollectedScatters: number;
    //Expand X
    private readonly _mysterySymbolSizes: number[];
    //Extra expand
    private readonly _numberOfExpandSymbolOnReel: number[];

    private readonly _featureBuyTimesBetValue: FeatureBuyTimesBetValue[];

    constructor(rawData: IHorribleHeroesInitData, dataParser: HorribleHeroesServerDataParser) {
        super(rawData, dataParser);
        this._superFSTriggered = dataParser.parseSuperFSTriggered(rawData);
        this._freespinSpinChoices = dataParser.parseFreespinSpinChoices(rawData);
        this._betWinsWays = dataParser.parseBetWinsInit((rawData));
        this.expandedSymbol = rawData.expandedSymbol;
        this.gameSizeEnteringFreespin = rawData.gameSizeEnteringFreespin;
        this.XSymbolPositions = rawData.XSymbolPositions;
        this._lockedWildWindow = rawData.lockedWildWindow;
        this._lockedWildNextSpin = rawData.lockedWildNextSpin;
        this._wildMultipliers = dataParser.parseWildMultipliers(rawData);
        this._numberOfExpandSymbolOnReel = dataParser.parseNumberOfExpandedSymbol(rawData);
        this.symbolSizesPos = dataParser.parseSymbolSizesPos(rawData);
        this.infectiousPos = dataParser.parseInfectiousPos();
        this._mysterySymbolSizes = dataParser.parseMysterSymSize();
        this._fsCollectedScatters = rawData.fsCollectedScatters;
        this._featureBuyTimesBetValue = rawData.featureBuyTimesBetValue;
    }

    get featureBuyTimesBetValue(): FeatureBuyTimesBetValue[] {
        return this._featureBuyTimesBetValue;
    }

    get getScattersCollected(): number {
        return this._fsCollectedScatters;
    }

    get freespinSpinChoices(): number[] {
        return this._freespinSpinChoices;
    }

    get superFSTriggered(): boolean {
        return this._superFSTriggered;
    }

    get getExpandedSymbol(): string {
        return this.expandedSymbol;
    }

    get getGameSizeEnteringFreespin(): number[] {
        return this.gameSizeEnteringFreespin;
    }

    get getXSymbolPositions(): number[] {
        return this.XSymbolPositions;
    }

    get lockedWildWindow(): boolean[][] {
        return this._lockedWildWindow;
    }

    get lockedWildNextSpin(): boolean[][] {
        return this._lockedWildNextSpin;
    }

    get wildMultipliers(): number[][] {
        return this._wildMultipliers;
    }

    get mysterySymbolSizes(): number[] {
        return this._mysterySymbolSizes;
    }

    get numberOfExpandSymbolOnReel(): number[] {
        return this._numberOfExpandSymbolOnReel;
    }

    get getSymbolSizesPos(): number[][] {
        return this.symbolSizesPos;
    }

    get getInfectiousPos(): number[][] {
        return this.infectiousPos;
    }

    public getGameSizeWildMultipliers(): number {
        const wildReelSize = [4, 4, 4, 4, 4];
        let sum = 1;
        if (this.wildMultipliers) {
            this.wildMultipliers.forEach((eachReel, reelId) => {
                eachReel.forEach((symSize) => {
                    if (symSize > 1) {
                        wildReelSize[reelId] = wildReelSize[reelId] + (symSize - 1);

                    }
                });
                sum = sum * wildReelSize[reelId];
            });

        }
        return sum;
    }

    protected isFeatureTotalWin(): boolean {
        return true;
    }
}